import i18n from "i18next";
import React, { useEffect, useState } from "react";
import { baseUrl } from "../../../helpers/constants";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { helperMethods } from "../../../helpers/helperMethods";
import { IDokument } from "../../../Models/IDokument";
import { IDokument2Dokumentgruppe } from "../../../Models/IDokument2Dokumentegruppe";
import { IDokumentSprache } from "../../../Models/IDokumentSprache";
import translationDE from "../../../locale/de/translation.json";
import translationEN from "../../../locale/en/translation.json";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  createTableColumn,
  Link,
  MessageBar,
  Text,
} from "@fluentui/react-components";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";

function ArtikelDocuments(props: any) {
  const [searchParam, setSearchParam] = useState<string>(props.artikelId);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [documents, setDocuments] = useState<IDokument[]>([]);

  const resources = {
    en: {
      translation: translationEN,
    },
    de: {
      translation: translationDE,
    },
  };

  // initialize i18next with catalog and language to use
  i18n.use(LanguageDetector).init({
    resources,
  });

  const getDocuments = () => {
    if (searchParam.length == 8) {
      setLoading(true);
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/documents/GetDocumentsByArtikelId?artikelId=${searchParam}`,
        )
        .then((data: any) => {
          setDocuments(data);
        })
        .catch((error) => {})
        .finally(() => {
          setSearched(true);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getDocuments();
  }, []);

  const [showDownloadNotification, setShowDownloadNotification] =
    useState(false);

  const columns = [
    // ------------Dateiname------------
    createTableColumn<IDokument>({
      columnId: "dateinameId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("FileName")}</Text>;
      },
      renderCell: (item) => {
        return (
          <>
            <Link
              onClick={(event: any) => {
                setShowDownloadNotification(true);
                helperMethods.downloadFile(item, true).finally(() => {
                  setShowDownloadNotification(false);
                });
              }}
            >
              {item.docFileName}
            </Link>
          </>
        );
      },
    }),
    // ------------Dokumentengruppe------------
    createTableColumn<IDokument>({
      columnId: "dokumentengruppeId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("docGroup")}</Text>;
      },
      renderCell: (item) => {
        return (
          <StackShim>
            {item.dokument2Dokumentgruppen.map(
              (gruppe: IDokument2Dokumentgruppe) => {
                return <Text>{gruppe.dokumentgruppe.nameDE}</Text>;
              },
            )}
          </StackShim>
        );
      },
    }),
    // ------------Sprachen------------
    createTableColumn<IDokument>({
      columnId: "sprachenId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("languages")}</Text>;
      },
      renderCell: (item) => {
        return (
          <StackShim>
            {item.dokumentSprachen.map((sprache: IDokumentSprache) => {
              return <Text>{sprache.sprache.nameDE}</Text>;
            })}
          </StackShim>
        );
      },
    }),
    // ------------Date------------
    createTableColumn<IDokument>({
      columnId: "dateId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("created")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {new Date(
              item.created != null ? item.created : "",
            ).toLocaleDateString()}
          </Text>
        );
      },
    }),
    // ------------Modified------------
    createTableColumn<IDokument>({
      columnId: "modifiedId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("changeDate")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.changeDate
              ? new Date(item.changeDate).toLocaleDateString()
              : ""}
          </Text>
        );
      },
    }),
  ];

  return (
    <div>
      <LuebPagedDataGrid
        columns={columns}
        items={documents}
        resizableColumns={true}
        columnSizingOptions={undefined}
      />
      {!searched && (
        <MessageBar intent="info">
          {i18n.t<string>("startSearchDocuments")}
        </MessageBar>
      )}
      {searched && documents.length == 0 && (
        <MessageBar intent="error">{i18n.t<string>("noItemsFound")}</MessageBar>
      )}
    </div>
  );
}

export default ArtikelDocuments;
